import { supabase } from '../lib/supabase';
import type { Database } from '../types/supabase';

type Supplier = Database['public']['Tables']['suppliers']['Row'];

export async function getSuppliers() {
  const { data, error } = await supabase
    .from('suppliers')
    .select('*')
    .eq('published', true)
    .order('company_name', { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function getSupplierById(id: string) {
  const { data, error } = await supabase
    .from('suppliers')
    .select('*')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
}

export async function searchSuppliers(query: string, categories?: string[]) {
  let queryBuilder = supabase
    .from('suppliers')
    .select('*')
    .eq('published', true);

  if (query) {
    queryBuilder = queryBuilder.or(`company_name.ilike.%${query}%,description.ilike.%${query}%`);
  }

  if (categories?.length) {
    queryBuilder = queryBuilder.contains('categories', categories);
  }

  const { data, error } = await queryBuilder;
  if (error) throw error;
  return data || [];
}